var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseHeadshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 70.75C77.8008 70.75 87.375 61.1758 87.375 49.375C87.375 37.5742 77.8008 28 66 28C54.1992 28 44.625 37.5742 44.625 49.375C44.625 61.1758 54.1992 70.75 66 70.75ZM85 75.5H76.8211C73.5258 77.0141 69.8594 77.875 66 77.875C62.1406 77.875 58.4891 77.0141 55.1789 75.5H47C36.5055 75.5 28 84.0055 28 94.5V96.875C28 100.809 31.1914 104 35.125 104H96.875C100.809 104 104 100.809 104 96.875V94.5C104 84.0055 95.4945 75.5 85 75.5Z",
    fill: "#791377",
    fillOpacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 65.5,
    stroke: "#791377",
    strokeOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseHeadshot);
export default __webpack_public_path__ + "static/media/base-headshot.38ec7d71b80b104e43bc2e288b5da11c.svg";
export { ForwardRef as ReactComponent };